import { Link } from "react-router-dom";
import JobKeyLogo from "./JobKeyLogo";
import LangSelect from "./LangSelect";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export function MarketingNav() {
  const { user } = useAuth();
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-40 border-b border-line/60 bg-bg/70 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
        <a href="/" data-testid="nav-logo-link" className="flex items-center">
          <JobKeyLogo />
        </a>
        <nav className="hidden items-center gap-8 font-mono text-xs uppercase tracking-[0.18em] text-muted md:flex">
          <a href="/#workflow" className="transition-colors hover:text-accent">{t("Workflow")}</a>
          <a href="/#pricing" className="transition-colors hover:text-accent">{t("Pricing")}</a>
          <a href="/contact" className="transition-colors hover:text-accent">{t("Contact")}</a>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <LangSelect />
          {user ? (
            <Link
              to="/app"
              data-testid="nav-open-app"
              className="rounded-full bg-accent px-4 py-2 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 sm:px-5"
            >
              {t("Open app")}
            </Link>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm font-bold text-ink transition-colors hover:text-accent">
                {t("Log in")}
              </Link>
              <Link
                to="/signup"
                data-testid="nav-signup"
                className="whitespace-nowrap rounded-full bg-accent px-4 py-2 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 sm:px-5"
              >
                {t("Get started")}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-line/60 bg-surface">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 py-14 md:grid-cols-4">
        <div>
          <JobKeyLogo />
          <p className="mt-3 max-w-xs text-sm text-muted">
            {t("The script-to-results workspace for short video. Made in India.")}
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Product")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="/#workflow" className="hover:text-accent">{t("Workflow")}</a></li>
            <li><a href="/#pricing" className="hover:text-accent">{t("Pricing")}</a></li>
            <li><Link to="/login" className="hover:text-accent">{t("Log in")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Legal")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:text-accent">{t("Terms")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-accent">{t("Privacy")}</Link></li>
            <li><Link to="/legal/refund" className="hover:text-accent">{t("Refund policy")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted">{t("Contact")}</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-accent">{t("Contact us")}</Link></li>
            <li className="text-muted">support@jobky.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line/60 py-5 text-center font-mono text-xs text-muted">
        © {new Date().getFullYear()} Jobky · jobky.in · {t("All prices exclude 18% GST")}
      </div>
    </footer>
  );
}
